import { render, staticRenderFns } from "./VaultFileItemWithPreview.vue?vue&type=template&id=7b3190b4&scoped=true&"
import script from "./VaultFileItemWithPreview.vue?vue&type=script&lang=ts&"
export * from "./VaultFileItemWithPreview.vue?vue&type=script&lang=ts&"
import style0 from "./VaultFileItemWithPreview.vue?vue&type=style&index=0&id=7b3190b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3190b4",
  null
  
)

export default component.exports